import axios from "axios";
import { Base_URL } from "../url";

// Create new task template
export const createTaskTemplate = async (templateData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaskTemplate/CreateTaskTemplate`,
      templateData,
      {
        params: { UserName: userId },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create task template"
    );
  }
};

// Get templates by organization
export const getTemplatesByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskTemplate/GetTemplatesByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch task templates"
    );
  }
};

// Get template by ID
export const getTemplateById = async (templateId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskTemplate/GetTemplateById/${templateId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch task template"
    );
  }
};

// Update task template
export const updateTaskTemplate = async (templateId, templateData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TaskTemplate/UpdateTaskTemplate/${templateId}`,
      templateData
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update task template"
    );
  }
};

// Delete task template
export const deleteTaskTemplate = async (templateId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/TaskTemplate/DeleteTaskTemplate/${templateId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete task template"
    );
  }
};
